angular.module('ecrd.queries').filter('queryStatus', ['gettextCatalog', function(gettextCatalog) {
    return function(statusKey) {
        switch (statusKey) {
            case 'new':
                return gettextCatalog.getString('Nueva');
            case 'updated':
                return gettextCatalog.getString('Actualizada');
            case 'resolution_proposed':
                return gettextCatalog.getString('Solución propuesta');
            case 'closed':
                return gettextCatalog.getString('Cerrada');
        }

        return statusKey;
    };
}]);
